/**
 * Picks the best synced record when multiple records exist for the same group (e.g. same groupId across accounts).
 * Prefers records that actually have member data (participantsCount > 0) so failed or empty syncs don't hide good data.
 * Order: 1) Prefer records with participantsCount > 0, 2) Then by participantsCount desc, 3) Then by updatedAt desc.
 */
export function pickBestSyncedGroupRecord<T extends { participantsCount?: number; updatedAt?: string | number | Date; [key: string]: any }>(
  records: T[]
): T {
  if (!records.length) throw new Error('pickBestSyncedGroupRecord: records array is empty');
  if (records.length === 1) return records[0];

  const sorted = [...records].sort((a, b) => {
    const countA = Number(a.participantsCount) || 0;
    const countB = Number(b.participantsCount) || 0;
    const hasMembersA = countA > 0 ? 1 : 0;
    const hasMembersB = countB > 0 ? 1 : 0;
    if (hasMembersB !== hasMembersA) return hasMembersA - hasMembersB;
    if (countB !== countA) return countA - countB;
    const timeA = new Date(a.updatedAt || 0).getTime();
    const timeB = new Date(b.updatedAt || 0).getTime();
    return timeA - timeB;
  });

  return sorted[sorted.length - 1];
}
